import React from 'react';
import PropTypes from 'prop-types';
import FullScreenPopup from '../FullScreenPopup';
import Button from '../Button';

class BadgePopup extends React.Component {
    constructor() {
        super();
        this.renderBadge = this.renderBadge.bind(this);
    }

    renderBadge(badge) {
        return (
            <div className="BadgePopup-badge" key={badge.id}>
                <div className="BadgePopup__image">
                    <img src={badge.image} alt={badge.name} />
                </div>
                <h1 className="BadgePopup__title">{badge.name}</h1>
                <p className="BadgePopup__description" dangerouslySetInnerHTML={{__html: badge.description}}></p>
            </div>
        );
    }

    render() {
        const { badges, isOpen, toggle } = this.props;
        const classes = ['BadgePopup', ...this.props.classes];
        return (
            <FullScreenPopup extraClasses={classes} isOpen={isOpen} toggle={toggle}>
                <div className="BadgePopup__inner">
                    {badges.map(this.renderBadge)}
                    <Button onClick={toggle} className="is-big">
                        OK
                    </Button>
                </div>
            </FullScreenPopup>
        );
    }
}

BadgePopup.propTypes = {
    classes: PropTypes.arrayOf(PropTypes.string),
    isOpen: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    badges: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string,
            image: PropTypes.string,
        })
    ).isRequired,
};

BadgePopup.defaultProps = {
    classes: [],
    isOpen: false,
};

export default BadgePopup;
